<script setup lang="ts">
defineOptions({
  name: 'Kategori'
})
const title = 'Kategori Kursus - Kognisi | Temukan Pengetahuan yang Anda Cari'
const keywords =
  'kategori kursus, Agrifood Best Seller, inspirasi, Leadership, Human Resources, Self Development, kognisi'
const description =
  'Temukan berbagai Kursus online menarik dan edukatif berdasarkan kategori pilihan Anda di Kognisi. Dari teknologi hingga gaya hidup, semua tersedia untuk Anda.'
const url = 'https://kognisi.id/kategori'

useHead({
  link: [{ rel: 'canonical', href: url }]
})

useSeoMeta({
  title,
  keywords,
  description,
  ogUrl: url,
  ogTitle: title,
  ogDescription: description,
  twitterTitle: title,
  twitterDescription: description,
  robots: 'index, follow'
})
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator />
    <main>
      <LazyModulesKategoriOrganismsWrapper />
    </main>
  </NuxtLayout>
</template>
